import { sendRequest, USER_URL } from 'api/utils';
import { Dictionary } from 'environment';

import {
	GetUsersByEmailsResponse,
	GetUsersByEmailsAxiosResponse,
	CheckIfEmailIsUniqueRequest,
	CheckIfEmailIsUniqueResponse,
	InviteUserResponse,
	InviteUserRequest,
	GetUsersByIdsResponse,
	GetUsersByIdsAxiosResponse
} from './types';

export const methods = {
	checkIfEmailIsUnique: 'checkIfEmailIsUnique',
	getUsersByEmails: 'getUsersByEmails',
	getUsersByIds: 'getUsersByIds',
	inviteUser: 'inviteUser'
};

export default () => ({
	getUsersByEmails: async (
		projectId: string,
		emails: string[]
	): Promise<GetUsersByEmailsResponse> => {
		const { data }: GetUsersByEmailsAxiosResponse = await sendRequest(USER_URL, {
			method: methods.getUsersByEmails,
			userAccesses: emails.map(email => ({
				projectId: Number(projectId),
				emailAddress: email
			}))
		});

		if (data.statusCode !== '200') {
			throw new Error(Dictionary.errors.api.accounts.couldNoGetUsersByEmail);
		}

		return data;
	},

	getUsersByIds: async (ids: string[]): Promise<GetUsersByIdsResponse> => {
		const { data }: GetUsersByIdsAxiosResponse = await sendRequest(USER_URL, {
			method: methods.getUsersByIds,
			userIds: ids
		});

		if (data.statusCode !== '200') {
			throw new Error(Dictionary.errors.api.accounts.couldNoGetUsersByIds);
		}

		return data;
	},

	checkIfEmailIsUnique: async (email: string) => {
		const { data }: CheckIfEmailIsUniqueResponse =
			await sendRequest<CheckIfEmailIsUniqueRequest>(USER_URL, {
				method: methods.checkIfEmailIsUnique,
				user: {
					emailAddress: email
				}
			});

		if (!data.emailUnique) throw new Error();
	},
	inviteUser: async ({
		emailAddress,
		projectId
	}: {
		emailAddress: string;
		projectId: string;
	}) => {
		const { data }: InviteUserResponse = await sendRequest<InviteUserRequest>(USER_URL, {
			method: methods.inviteUser,
			emailAddress,
			projectId
		});

		if (!data) throw new Error();
	}
});
